(function () {
  var MINI_SHEEN_VARIANT_ID = 30360979137;
  var MIN_QUALIFYING_QTY = 6;
  var DISMISS_KEY = 'miniSheenGiftDismissed';

  var isHandling = false;
  var giftWasInCart = null;

  function getCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function qualifyingQuantity(cart) {
    return cart.items.reduce(function (sum, item) {
      return item.variant_id === MINI_SHEEN_VARIANT_ID ? sum : sum + item.quantity;
    }, 0);
  }

  function cartSectionIds() {
    var miniCart = document.querySelector('mini-cart');
    return miniCart ? miniCart.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }

  function refreshCart(parsedState) {
    var miniCart = document.querySelector('mini-cart');
    var onCartPage = document.querySelector('cart-items');
    if (miniCart && !onCartPage && parsedState && parsedState.sections) {
      miniCart.renderContents(parsedState);
    } else {
      location.reload();
    }
  }

  function handleMiniSheenGift() {
    if (isHandling) return;
    isHandling = true;

    getCart().then(function (cart) {
      var giftItem = cart.items.find(function (i) { return i.variant_id === MINI_SHEEN_VARIANT_ID; });
      var qty = qualifyingQuantity(cart);

      if (qty < MIN_QUALIFYING_QTY) {
        sessionStorage.removeItem(DISMISS_KEY);
        giftWasInCart = false;

        if (giftItem) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: giftItem.key,
              quantity: 0,
              sections: cartSectionIds(),
              sections_url: window.location.pathname
            })
          }).then(function (res) { return res.json(); })
            .then(refreshCart)
            .finally(function () {
              isHandling = false;
            });
          return;
        }

        isHandling = false;
        return;
      }

      if (giftItem) {
        giftWasInCart = true;
        isHandling = false;
        return;
      }

      if (giftWasInCart === true) {
        sessionStorage.setItem(DISMISS_KEY, '1');
        giftWasInCart = false;
        isHandling = false;
        return;
      }

      giftWasInCart = false;

      if (sessionStorage.getItem(DISMISS_KEY) === '1') {
        isHandling = false;
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: MINI_SHEEN_VARIANT_ID, quantity: 1 }],
          sections: cartSectionIds(),
          sections_url: window.location.pathname
        })
      }).then(function (res) { return res.json(); })
        .then(function (parsedState) {
          giftWasInCart = true;
          refreshCart(parsedState);
        }).finally(function () {
          isHandling = false;
        });
    }).catch(function () {
      isHandling = false;
    });
  }

  document.addEventListener('DOMContentLoaded', handleMiniSheenGift);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleMiniSheenGift);
  }
})();
